import { useRef } from 'react';
import PropTypes from 'prop-types';
import { css } from '@eti/styles';
import useStickySidebar from '../hooks/useStickySidebar';

const wrapperStyles = css`
  position: sticky;
`;

const StickySidebar = ({ children, containerRef, topSpacing }) => {
  const innerRef = useRef();
  const { sidebarStyles, topStyles } = useStickySidebar(topSpacing, innerRef, containerRef);

  return (
    <>
      <div style={topStyles} />
      <div className={wrapperStyles} ref={innerRef} style={sidebarStyles}>
        {children}
      </div>
    </>
  );
};

StickySidebar.propTypes = {
  children: PropTypes.node,
  containerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  topSpacing: PropTypes.number,
};

export default StickySidebar;
